import { img } from "@/lib/images";

// ============================================================
// Pressebeiträge, die nur als Zeitungsausschnitt (Scan) vorliegen
// Alle Dateien liegen in Supabase unter
// site-images/balivwtour/nostalgia/
// ============================================================

export type PressScan = {
  src: string;
  captionKey: string;
};

/** Salzburger Nachrichten, 30. November 2004 – einseitiger Bericht auf Seite 4 */
export const salzburgerScans: PressScan[] = [
  {
    src: img("balivwtour/nostalgia/zeitungsber_sn_dez_04_large.jpg"),
    captionKey: "nost_press_11_scan_1",
  },
];

/** Touristik Aktuell, Mai 2006 – einseitiger Bericht */
export const touristikAktuellScans: PressScan[] = [
  {
    src: img("balivwtour/nostalgia/touristik_aktuell_gery_%20bericht.jpg"),
    captionKey: "nost_press_13_scan_1",
  },
];

/** NÖN, November 2005 – zweiseitiger Bericht */
export const noenScans: PressScan[] = [
  {
    src: img("balivwtour/nostalgia/bali-1.jpg"),
    captionKey: "nost_press_14_scan_1",
  },
  {
    src: img("balivwtour/nostalgia/bali-2.jpg"),
    captionKey: "nost_press_14_scan_2",
  },
];